<template>
  <div class="load-more pointer flex justify-center">
    <div
      :class="['load-more-btn', 'flex', 'justify-center', 'items-center',{'isNoMore':isNoMore}]"
      @click="loadMoreFun"
    >
      {{isNoMore?'已加载全部':'查看更多'}}<DownOutlined v-if="!isNoMore" />
    </div>
    <div
      class="collapse-btn flex justify-center items-center"
      @click="packUpFun"
    >
      <DoubleLeftOutlined />
    </div>
  </div>
</template>
<script setup>
import { ref,  } from "vue";
import { DownOutlined, DoubleLeftOutlined } from "@ant-design/icons-vue";
const props = defineProps({
  isNoMore:{
    type:Boolean,
    default:false
  }
})
const emits = defineEmits(["loadMore", "packUp"]);
function loadMoreFun() {
  if(!props.isNoMore){
    emits("loadMore");
  }
}
function packUpFun() {
  emits("packUp");
}
</script>
<style lang="scss" scoped>
.load-more {
    padding: 10px 0 70px;
  .load-more-btn {
    width: 112px;
    height: 30px;
    background: #ffffff;
    box-shadow: 0px 0px 14px -2px rgba(36, 37, 39, 0.1);
    border-radius: 4px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 10px;
    &.isNoMore{
      cursor: not-allowed;
    }
  }
  .collapse-btn {
    width: 30px;
    height: 30px;
    background: #ffffff;
    box-shadow: 0px 0px 14px -2px rgba(36, 37, 39, 0.1);
    border-radius: 4px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #999999;
    transform:rotate(90deg);
  }
}
</style>
